import { Authenticator } from './components/core/Authenticator';
import SideNavigationComponent from './components/core/home/navigation';
import { BrowserRouter as Router } from 'react-router-dom';
import { AppLayout, HelpPanel } from '@cloudscape-design/components';
import Breadcrumbs from './components/core/home/breadcrumbs';
import RoutesComponent from './components/core/home/Routes';
import TopNavigationComponent from './components/core/home/TopNavigation';

import { useCallback, useEffect, useState } from 'react';
import { JSX } from 'react/jsx-runtime';



export default function App() {
  const [isNavigationOpen, setIsNavigationOpen] = useState(false);
  const [dynamicHelpMessage, setDynamicHelpMessage] = useState(''); // State to store dynamic help message

  // Function to update the dynamic help message from Routes.tsx
  const updateDynamicHelpMessage = (message: string) => {
    // console.log('Received dynamic help message:', message); // Debugging console.log

    setDynamicHelpMessage(message);
  };



  const [splitPanelContent, setSplitPanelContent] = useState<JSX.Element>()
  const [splitPanelOpen, setSplitPanelOpen] = useState(false)

  const wrapperSetSplitPanelContent = useCallback((val: JSX.Element) => {
    setSplitPanelContent(val);
  }, []);
  const wrapperSetSplitPanelOpen = useCallback((val: boolean) => {
    setSplitPanelOpen(val);
  }, []);

  useEffect(()=>{
    setSplitPanelContent(<></>)
  },[])

  // const setSplitPanelContentCallback = useCallback((content:any)=>{
  //   setSplitPanelContent(content)
  // }, [splitPanelContent])

  // const updateSplitPanel = (splitPanelContent:any) => {
  //   setSplitPanelContent(splitPanelContent)
  // }
  // const [splitPanelObject, setSplitPanelObject] = useState({
  //   "splitPanelContent": splitPanelContent,
  //   "updateSplitPanel": updateSplitPanel,
  //   "splitPanelOpen": splitPanelOpen,
  // })

  // useEffect(()=>{
  //   setSplitPanelObject({
  //     "splitPanelContent": splitPanelContent,
  //     "splitPanelOpen": splitPanelOpen,
  //   })
  // }, [splitPanelContent, splitPanelOpen])

  return (
    <Authenticator>
      <Router>
        <div id='top-nav'>
          <TopNavigationComponent />
        </div>
        <AppLayout
          headerSelector='#top-nav'
          ariaLabels={{
            navigation: 'Navigation drawer',
            navigationClose: 'Close navigation drawer',
            navigationToggle: 'Open navigation drawer',
            notifications: 'Notifications',
            tools: 'Help panel',
            toolsClose: 'Close help panel',
            toolsToggle: 'Open help panel',
          }}
          navigation={<SideNavigationComponent />}
          navigationOpen={isNavigationOpen}
          onNavigationChange={(event) => {
            setIsNavigationOpen(event.detail.open);
          }}
          breadcrumbs={<Breadcrumbs />}
          content={<RoutesComponent
            updateDynamicHelpMessage={updateDynamicHelpMessage}
            updateSplitPanelOpen={wrapperSetSplitPanelOpen}
            updateSplitPanelFunction={wrapperSetSplitPanelContent}
          />}
          splitPanelOpen={splitPanelOpen}
          onSplitPanelToggle={()=>setSplitPanelOpen(!splitPanelOpen)}
          splitPanel={splitPanelContent}
          tools={
            <HelpPanel>
              <h2>Help</h2>
              <p>{dynamicHelpMessage}</p> {/* Display dynamic help message */}
            </HelpPanel>
          }
        />
      </Router>
    </Authenticator>
  );
}
